import axios from "../../common"

export const ApiListUsers = async () => {
    return axios.get("/auth/users/list", {withCredentials: true})
}

export const ApiDeleteUser = async (id: number) => {
    return axios.delete( `/auth/users/detail/${id}/`, {withCredentials: true} )
}

export const ApiEnableUser = async (id: number) => {
    return axios.put( `/auth/users/detail/${id}/`, {is_active: true}, {withCredentials: true} )
}

export const ApiUpdateUser = async (id: number, data: any) => {
    return axios.put( `/auth/users/detail/${id}/`, data, {withCredentials: true} )
}

export const ApiCreateUser = async (data: any) => {
    return axios.post( `/auth/users/create/`, data, {withCredentials: true} )
}